import { combineReducers } from 'redux'
import auth from './auth.js'
import dataExpiry from './dataExpiry'
import shareDataElement from './shareDataElement'
import staticData from './static-data'
import version from './version'
import tt from './trade-trust'
import isDirty from './isDirty.js'

export default combineReducers({ auth, version, staticData, dataExpiry, shareDataElement, tt, isDirty })
